// begin SnapEngage code 
(function() {
	var se = document.createElement('script'); se.type = 'text/javascript'; se.async = true;
	se.src = '//storage.googleapis.com/code.snapengage.com/js/6b27b376-126d-4342-a10f-016914f4b57a.js';
	var done = false;
	se.onload = se.onreadystatechange = function() {
		if (!done&&(!this.readyState||this.readyState==='loaded'||this.readyState==='complete')) {
			done = true;
			SnapEngage.getAgentStatusAsync(function (online) {
				var buttonText;
				var chatButtonId = 'live-chat';
				if (online) {
					buttonText = 'Live Chat';
				} else {
					buttonText = 'Message';
				}

				if (document.getElementById(chatButtonId)) {
					document.getElementById(chatButtonId).innerHTML = buttonText;

					SnapEngage.hideButton();
				}
			});
		}
	};
	var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(se, s);
})()
// end SnapEngage code
